<template>
  <head>
    <meta charset="utf-8" />
    <title>Desk Birdy | Business Permits</title>
    <meta name="viewport" content="width=device-width, initial-scale=1.0">
    <meta content="Rental management system by Nouveta LTD" name="description" />
    <meta content="Kelvin Njuguna" name="author" />
    <link rel="shortcut icon" href="assets/images/favicon.svg">
    <link href="assets/libs/dropzone/min/dropzone.min.css" rel="stylesheet" type="text/css" />
    <link href="assets/libs/datatables.net-bs4/css/dataTables.bootstrap4.min.css" rel="stylesheet" type="text/css" />
    <link href="assets/libs/datatables.net-buttons-bs4/css/buttons.bootstrap4.min.css" rel="stylesheet" type="text/css" />
    <link href="assets/css/bootstrap.min.css" id="bootstrap-style" rel="stylesheet" type="text/css" />
    <link rel="stylesheet" href="https://cdn.jsdelivr.net/npm/bootstrap-select@1.13.14/dist/css/bootstrap-select.min.css">
    <link href="assets/css/icons.min.css" rel="stylesheet" type="text/css" />
    <link rel="stylesheet" href="assets/libs/owl.carousel/assets/owl.carousel.min.css">
    <link rel="stylesheet" href="assets/libs/owl.carousel/assets/owl.theme.default.min.css">
    <link href="assets/css/app.min.css" id="app-style" rel="stylesheet" type="text/css" />
    <link href="assets/css/custom.css" id="app-style" rel="stylesheet" type="text/css" />
  </head>

  <body @contextmenu.prevent data-sidebar="dark">
  <div id="layout-wrapper">
    <NavigationBar/>

    <div class="content-minimize">
      <div class="page-content">
        <div class="container-fluid">
          <!-- Page Header -->
          <div class="row">
            <div class="col-12">
              <div class="page-header-box mb-4">
                <h4 class="page-header-title">APPROVED APPLICATIONS</h4>
                <p class="page-header-description">Manage approved licence invoices and payments</p>
              </div>
            </div>
          </div>

          <ToolBarLiquor/>

          <!-- Statistics Cards -->
          <div class="row mb-4">
            <div class="col-xl-3 col-md-6 mb-3 mb-xl-0">
              <div class="card stat-card border-0 shadow-sm h-100">
                <div class="card-body">
                  <div class="d-flex align-items-center">
                    <div class="stat-icon-wrapper bg-success-subtle rounded-circle me-3">
                      <i class="bx bx-check-shield text-success"></i>
                    </div>
                    <div class="flex-grow-1">
                      <p class="text-muted mb-1 small text-uppercase fw-semibold">Approved</p>
                      <div class="d-flex align-items-baseline">
                        <h3 class="mb-0 fw-bold">{{ stats.totalApplications }}</h3>
                        <span class="badge bg-success-subtle text-success ms-2 small">Licences</span>
                      </div>
                    </div>
                  </div>
                </div>
                <div class="card-footer bg-transparent border-0 pt-0">
                  <div class="progress" style="height: 4px;">
                    <div class="progress-bar bg-success" style="width: 100%"></div>
                  </div>
                </div>
              </div>
            </div>

            <div class="col-xl-3 col-md-6 mb-3 mb-xl-0">
              <div class="card stat-card border-0 shadow-sm h-100">
                <div class="card-body">
                  <div class="d-flex align-items-center">
                    <div class="stat-icon-wrapper bg-primary-subtle rounded-circle me-3">
                      <i class="bx bx-check-double text-primary"></i>
                    </div>
                    <div class="flex-grow-1">
                      <p class="text-muted mb-1 small text-uppercase fw-semibold">Fully Paid</p>
                      <div class="d-flex align-items-baseline">
                        <h3 class="mb-0 fw-bold text-primary">{{ stats.paidCount }}</h3>
                        <span class="text-muted ms-2 small">ready for cert</span>
                      </div>
                    </div>
                  </div>
                </div>
                <div class="card-footer bg-transparent border-0 pt-0">
                  <div class="progress" style="height: 4px;">
                    <div class="progress-bar bg-primary" :style="{width: getProgressWidth('paid')}"></div>
                  </div>
                </div>
              </div>
            </div>

            <div class="col-xl-3 col-md-6 mb-3 mb-xl-0">
              <div class="card stat-card border-0 shadow-sm h-100">
                <div class="card-body">
                  <div class="d-flex align-items-center">
                    <div class="stat-icon-wrapper bg-warning-subtle rounded-circle me-3">
                      <i class="bx bx-time-five text-warning"></i>
                    </div>
                    <div class="flex-grow-1">
                      <p class="text-muted mb-1 small text-uppercase fw-semibold">Pending Payment</p>
                      <div class="d-flex align-items-baseline">
                        <h3 class="mb-0 fw-bold text-warning">{{ stats.pendingCount }}</h3>
                        <span class="text-muted ms-2 small">with balance</span>
                      </div>
                    </div>
                  </div>
                </div>
                <div class="card-footer bg-transparent border-0 pt-0">
                  <div class="progress" style="height: 4px;">
                    <div class="progress-bar bg-warning" :style="{width: getProgressWidth('pending')}"></div>
                  </div>
                </div>
              </div>
            </div>

            <div class="col-xl-3 col-md-6">
              <div class="card stat-card border-0 shadow-sm h-100 bg-gradient-approved text-white">
                <div class="card-body">
                  <div class="d-flex align-items-center">
                    <div class="stat-icon-wrapper bg-white bg-opacity-25 rounded-circle me-3">
                      <i class="bx bx-wallet text-white"></i>
                    </div>
                    <div class="flex-grow-1">
                      <p class="text-white-50 mb-1 small text-uppercase fw-semibold">Total Invoiced</p>
                      <div class="d-flex align-items-baseline">
                        <h3 class="mb-0 fw-bold text-white">{{ formatCurrency(stats.totalInvoiced) }}</h3>
                      </div>
                      <small class="text-white-50">Collected: {{ formatCurrency(stats.totalPaid) }}</small>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>

          <!-- Main Content Card -->
          <div class="row">
            <div class="col-12">
              <div class="card border-0 shadow-sm">
                <!-- Card Header -->
                <div class="card-header bg-white py-3 border-bottom">
                  <div class="row align-items-center g-3">
                    <div class="col-lg-4 col-md-6">
                      <div class="d-flex align-items-center">
                        <div class="header-icon me-3">
                          <i class="bx bx-check-shield"></i>
                        </div>
                        <div>
                          <h5 class="card-title mb-0 fw-semibold">Approved Invoices</h5>
                          <small class="text-muted">{{ totalItems }} licence invoices</small>
                        </div>
                      </div>
                    </div>
                    <div class="col-lg-8 col-md-6">
                      <div class="d-flex flex-wrap justify-content-lg-end gap-2">
                        <!-- Search -->
                        <div class="search-box">
                          <i class="bx bx-search search-icon"></i>
                          <input v-model="search" type="text" class="form-control"
                                 placeholder="Search invoice, business...">
                        </div>
                        <!-- Date Range -->
                        <div class="d-flex align-items-center gap-2">
                          <input v-model="dateFrom" type="date" class="form-control form-control-sm date-input">
                          <span class="text-muted small">to</span>
                          <input v-model="dateTo" type="date" class="form-control form-control-sm date-input">
                        </div>
                        <!-- Actions -->
                        <button @click="downloadApplications()" class="btn btn-outline-primary btn-sm">
                          <i class="bx bx-download"></i> {{ download }}
                        </button>
                        <button class="btn btn-soft-secondary btn-sm" type="button"
                                data-bs-toggle="collapse" data-bs-target="#filterSection">
                          <i class="bx bx-filter-alt"></i> Filters
                        </button>
                      </div>
                    </div>
                  </div>
                </div>

                <!-- Collapsible Filters -->
                <div class="collapse" id="filterSection">
                  <div class="card-body bg-light border-bottom py-3">
                    <div class="row g-3">
                      <div class="col-md-3">
                        <label class="form-label small fw-semibold text-muted">Business Category</label>
                        <select @change="getTradeSubCategory($event)" class="form-select form-select-sm">
                          <option value="">All Categories</option>
                          <option :key="index" :value="item.incomeTypeId" v-for="(item, index) in tradeCategories">
                            {{ item.incomeTypeDescription }}
                          </option>
                        </select>
                      </div>
                      <div class="col-md-3">
                        <label class="form-label small fw-semibold text-muted">Sub Category</label>
                        <select @change="selectedTradeSubCategory($event)" class="form-select form-select-sm">
                          <option value="">All Sub Categories</option>
                          <option :key="index" :value="JSON.stringify(item)" v-for="(item, index) in tradeSubCategories">
                            {{ item.feeDescription }}
                          </option>
                        </select>
                      </div>
                      <div class="col-md-3">
                        <label class="form-label small fw-semibold text-muted">Sub County</label>
                        <select @change="selectedSubCounty($event)" class="form-select form-select-sm">
                          <option value="">All Sub Counties</option>
                          <option :key="index" :value="JSON.stringify(item)" v-for="(item, index) in subCounties">
                            {{ item.subCountyName }}
                          </option>
                        </select>
                      </div>
                      <div class="col-md-3">
                        <label class="form-label small fw-semibold text-muted">Ward</label>
                        <select @change="selectedWard($event)" class="form-select form-select-sm">
                          <option value="">All Wards</option>
                          <option :key="index" :value="JSON.stringify(item)" v-for="(item, index) in wards">
                            {{ item.wardName }}
                          </option>
                        </select>
                      </div>
                    </div>
                  </div>
                </div>

                <!-- Table -->
                <div class="table-responsive">
                  <table class="table table-hover align-middle mb-0">
                    <thead class="bg-light">
                    <tr>
                      <th class="border-0 text-uppercase small fw-bold text-muted py-3">#</th>
                      <th class="border-0 text-uppercase small fw-bold text-muted py-3">Invoice No.</th>
                      <th class="border-0 text-uppercase small fw-bold text-muted py-3">Business</th>
                      <th class="border-0 text-uppercase small fw-bold text-muted py-3">Applicant</th>
                      <th class="border-0 text-uppercase small fw-bold text-muted py-3">Licence</th>
                      <th class="border-0 text-uppercase small fw-bold text-muted py-3">Location</th>
                      <th class="border-0 text-uppercase small fw-bold text-muted py-3">Inspected</th>
                      <th class="border-0 text-uppercase small fw-bold text-muted py-3 text-center">Status</th>
                      <th class="border-0 text-uppercase small fw-bold text-muted py-3 text-end">Amount</th>
                      <th class="border-0 text-uppercase small fw-bold text-muted py-3 text-center">Actions</th>
                    </tr>
                    </thead>
                    <tbody>
                    <tr v-for="(item, index) in applications" :key="index" class="border-bottom">
                      <td class="py-3">
                        <span class="text-muted small">{{ ((currentPage - 1) * pageSize) + index + 1 }}</span>
                      </td>
                      <td class="py-3">
                        <a href="javascript: void(0);" class="fw-semibold text-primary text-decoration-none">
                          {{ item.licenceBillNo}}
                        </a>
                      </td>
                      <td class="py-3">
                        <div class="d-flex align-items-center">
                          <div class="avatar-sm me-2">
                              <span class="avatar-title rounded-circle bg-success-subtle text-success fw-bold">
                                {{ getInitials(item.businessName) }}
                              </span>
                          </div>
                          <span class="text-truncate d-inline-block" style="max-width: 130px;" :title="item.businessName">
                              {{ item.businessName || '-' }}
                            </span>
                        </div>
                      </td>
                      <td class="py-3">
                        <div>
                          <div class="fw-medium text-truncate" style="max-width: 120px;">{{ item.applicant || '-' }}</div>
                          <small class="text-muted">{{ item.phoneNumber || '-' }}</small>
                        </div>
                      </td>
                      <td class="py-3">
                        <div>
                          <span class="badge bg-light text-dark fw-normal">{{ item.licenceCategory || '-' }}</span>
                          <div class="small text-muted mt-1" v-if="item.licenceDuration">
                            <i class="bx bx-time-five"></i> {{ item.licenceDuration }}
                          </div>
                        </div>
                      </td>
                      <td class="py-3">
                        <div>
                          <div class="small fw-medium">{{ item.subCountyName || '-' }}</div>
                          <small class="text-muted">{{ item.wardName || '-' }}</small>
                        </div>
                      </td>
                      <td class="py-3">
                        <span class="text-muted small">{{ formatDate(item.dateInspected) }}</span>
                      </td>
                      <td class="py-3 text-center">
                        <span class="badge bg-success rounded-pill px-3">{{ item.status }}</span>
                      </td>
                      <td class="py-3 text-end">
                        <div>
                          <div class="fw-bold">{{ formatCurrency(item.licenceDetailAmount) }}</div>
                          <small :class="parseFloat(item.licenceBillBalance) > 0 ? 'text-danger' : 'text-success'">
                            Bal: {{ formatCurrency(item.licenceBillBalance) }}
                          </small>
                        </div>
                      </td>
                      <td class="py-3 text-center">
                        <div class="d-flex gap-1 justify-content-center">
                          <button @click="applicationDetails(item)" type="button"
                                  class="btn btn-sm btn-soft-primary rounded-circle"
                                  data-bs-toggle="modal" data-bs-target=".receipting-modal"
                                  title="View Details">
                            <i class="bx bx-show"></i>
                          </button>
                          <button @click="printViewBill(item)" type="button"
                                  class="btn btn-sm btn-soft-success rounded-circle"
                                  title="Print Invoice">
                            <i class="bx bx-printer"></i>
                          </button>
                          <button v-if="getRight('LIQUOR LICENCE RECEIVE PAYMENT') && parseFloat(item.licenceBillBalance) > 0"
                                  @click="openPaymentModal(item.licenceBillNo)"
                                  type="button"
                                  class="btn btn-sm btn-soft-warning rounded-circle"
                                  data-toggle="modal" data-target="#payment-modal_"
                                  title="Receive Payment">
                            <i class="bx bx-credit-card"></i>
                          </button>
                        </div>
                      </td>
                    </tr>
                    </tbody>
                  </table>
                </div>

                <!-- Loading State -->
                <div class="text-center py-5" v-if="loading">
                  <div class="spinner-border text-primary" role="status"></div>
                  <p class="mt-2 text-muted mb-0">Loading applications...</p>
                </div>

                <!-- Empty State -->
                <div class="text-center py-5" v-if="applications.length < 1 && !loading">
                  <div class="empty-icon mb-3">
                    <i class="bx bx-check-shield"></i>
                  </div>
                  <h5 class="text-muted">No Approved Applications</h5>
                  <p class="text-muted small mb-3">No approved applications found for the selected criteria</p>
                  <button @click="resetFilters()" class="btn btn-primary btn-sm">
                    <i class="bx bx-refresh me-1"></i> Reset Filters
                  </button>
                </div>

                <!-- Footer with Pagination -->
                <div class="card-footer bg-white border-top py-3" v-if="applications.length > 0">
                  <div class="row align-items-center">
                    <div class="col-md-5">
                      <p class="text-muted mb-0 small">
                        Showing <strong>{{ ((currentPage - 1) * pageSize) + 1 }}</strong> to
                        <strong>{{ Math.min(currentPage * pageSize, totalItems) }}</strong> of
                        <strong>{{ totalItems }}</strong> entries
                      </p>
                    </div>
                    <div class="col-md-7">
                      <div class="d-flex align-items-center justify-content-md-end gap-3">
                        <select class="form-select form-select-sm" style="width: 80px;" v-model="pageSize">
                          <option value="10">10</option>
                          <option value="25">25</option>
                          <option value="50">50</option>
                          <option value="100">100</option>
                          <option value="500">500</option>
                          <option value="1000">1000</option>
                          <option value="5000">5000</option>
                          <option value="10000">10000</option>
                        </select>
                        <nav>
                          <ul class="pagination pagination-sm mb-0">
                            <li :class="{ disabled: currentPage === 1 }" class="page-item">
                              <a @click.prevent="prevPage" class="page-link" href="javascript: void(0);">
                                <i class="bx bx-chevron-left"></i>
                              </a>
                            </li>
                            <li v-for="page in visiblePages" :key="page"
                                :class="{ active: currentPage === page, disabled: page === '...' }" class="page-item">
                              <a @click.prevent="page !== '...' && goToPage(page)" class="page-link" href="javascript: void(0);">{{ page }}</a>
                            </li>
                            <li :class="{ disabled: currentPage === totalPages }" class="page-item">
                              <a @click.prevent="nextPage" class="page-link" href="javascript: void(0);">
                                <i class="bx bx-chevron-right"></i>
                              </a>
                            </li>
                          </ul>
                        </nav>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

      <!-- Approved Details Modal -->
      <ApprovedDetailsModal
          :application="application"
          :applicationStatuses="applicationStatuses"
          @print-bill="handlePrintBill"
          @receive-payment="openPaymentModal"
      />

      <!-- Payment Modal -->
      <div class="modal fade" id="payment-modal_" data-backdrop="static" data-keyboard="false" tabindex="-1"
           role="dialog" data-bs-keyboard="false" data-bs-backdrop="static">
        <div class="modal-dialog modal-dialog-centered" role="document">
          <div class="modal-content border-0 shadow">
            <div class="modal-header bg-light border-0 py-3">
              <div class="d-flex align-items-center">
                <div class="payment-modal-icon me-3">
                  <i class="bx bx-credit-card"></i>
                </div>
                <h5 class="modal-title mb-0 fw-semibold">Receive Payment</h5>
              </div>
              <button type="button" class="btn btn-light rounded-circle close-modal" data-dismiss="modal" aria-label="Close">
                <i class="bx bx-x"></i>
              </button>
            </div>
            <div class="modal-body p-4">
              <div class="payment-panel-parent">
                <!-- Initial Panel -->
                <div v-if="paymentPanel" class="text-center payment-panel">
                  <div class="success-image mb-4">
                    <img src="assets/images/bills.svg" height="150" alt="">
                  </div>
                  <h5 class="text-dark fw-bold">{{ message || 'Invoice Ready' }}</h5>
                  <p class="text-muted mb-4">Bill No: <strong>{{ billDetails.billNo }}</strong></p>
                  <div class="amount-display mb-4">
                    <span class="text-muted small">Amount Due</span>
                    <h2 class="text-success mb-0">KES {{ numberFormat(billDetails.billBalance) }}</h2>
                  </div>
                  <div class="d-grid gap-2">
                    <button @click="showPaymentMethod()" type="button" class="btn btn-primary">
                      <i class="bx bx-credit-card me-2"></i> Proceed to Payment
                    </button>
                    <button @click="printBill()" type="button" class="btn btn-outline-secondary">
                      <i class="bx bx-printer me-2"></i> Print Bill
                    </button>
                  </div>
                </div>

                <!-- Payment Method Panel -->
                <div v-if="paymentMethod" class="payment-panel">
                  <h6 class="fw-semibold mb-3">Select Payment Method</h6>

                  <div class="accordion" id="paymentAccordion">
                    <!-- MPESA -->
                    <div class="accordion-item border rounded mb-2">
                      <h2 class="accordion-header">
                        <button class="accordion-button" type="button" data-toggle="collapse" data-target="#mpesaPanel">
                          <img src="assets/images/users/mpesa.jpg" class="rounded-circle me-3" height="40" alt="MPesa">
                          <div>
                            <strong>M-PESA</strong>
                            <small class="d-block text-muted">Send payment request to customer</small>
                          </div>
                        </button>
                      </h2>
                      <div id="mpesaPanel" class="accordion-collapse collapse show" data-bs-parent="#paymentAccordion">
                        <div class="accordion-body">
                          <p class="small text-muted">
                            A payment request of <strong class="text-dark">KES {{ numberFormat(billDetails.billBalance) }}</strong>
                            will be sent to the phone number below.
                          </p>
                          <div class="mb-3">
                            <label class="form-label small">Phone Number</label>
                            <input v-model="phoneNumber" type="tel" class="form-control form-control-lg"
                                   placeholder="07XX XXX XXX">
                          </div>
                          <button @click="showTransactionSummary('MPESA')" class="btn btn-success w-100">
                            <i class="bx bx-send me-2"></i> Send Request
                          </button>
                        </div>
                      </div>
                    </div>

                    <!-- BANK -->
                    <div class="accordion-item border rounded">
                      <h2 class="accordion-header">
                        <button class="accordion-button collapsed" type="button" data-toggle="collapse" data-target="#bankPanel">
                          <img src="assets/images/users/money.jpg" class="rounded-circle me-3" height="40" alt="Bank">
                          <div>
                            <strong>Bank Receipt</strong>
                            <small class="d-block text-muted">Enter bank transaction reference</small>
                          </div>
                        </button>
                      </h2>
                      <div id="bankPanel" class="accordion-collapse collapse" data-bs-parent="#paymentAccordion">
                        <div class="accordion-body">
                          <div class="mb-3">
                            <label class="form-label small">Bank Receipt Number</label>
                            <input v-model="paymentData.bankReceiptNo" type="text" class="form-control form-control-lg"
                                   placeholder="Enter receipt number">
                          </div>
                          <button @click="showTransactionSummary('BANK')" class="btn btn-warning w-100">
                            Continue
                          </button>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>

                <!-- Transaction Summary Panel -->
                <div v-if="transactionSummary" class="payment-panel">
                  <h6 class="fw-semibold mb-3">Confirm Payment</h6>
                  <div class="summary-card p-3 bg-light rounded mb-4">
                    <div class="d-flex justify-content-between mb-2">
                      <span class="text-muted">Bill No.</span>
                      <span class="fw-semibold">{{ billDetails.billNo }}</span>
                    </div>
                    <div class="d-flex justify-content-between mb-2">
                      <span class="text-muted">Bill For</span>
                      <span>{{ billDetails.incomeTypeDescription }}</span>
                    </div>
                    <div class="d-flex justify-content-between mb-2">
                      <span class="text-muted">Payment Method</span>
                      <span class="badge bg-primary">{{ paymentData.paymentMode }}</span>
                    </div>
                    <hr>
                    <div class="d-flex justify-content-between">
                      <span class="fw-bold">Total Amount</span>
                      <span class="fw-bold text-success fs-5">KES {{ numberFormat(billDetails.billBalance) }}</span>
                    </div>
                  </div>

                  <div v-if="paymentData.paymentMode === 'MPESA'" class="alert alert-info small">
                    <i class="bx bx-info-circle me-2"></i>
                    A payment request will be sent to <strong>{{ phoneNumber }}</strong>.
                    Please enter your M-PESA PIN when prompted.
                  </div>

                  <p v-if="message" class="text-center text-muted">{{ message }}</p>

                  <button @click="makePayment()" class="btn btn-primary w-100">
                    <i class="bx bx-check-circle me-2"></i> Confirm Payment
                  </button>
                </div>

                <!-- Transaction Completed Panel -->
                <div v-if="transactionCompleted" class="text-center payment-panel">
                  <div class="success-icon mb-4">
                    <i class="bx bx-check-circle text-success"></i>
                  </div>
                  <h4 class="text-success fw-bold">Payment Successful!</h4>
                  <p class="text-muted">
                    <strong>KES {{ numberFormat(receiptDetails.receiptAmount) }}</strong> received for
                    <strong>{{ receiptDetails.billNo }}</strong>
                  </p>
                  <button @click="printReceipt()" class="btn btn-primary">
                    <i class="bx bx-printer me-2"></i> Print Receipt
                  </button>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

      <footer class="footer">
        <div class="container-fluid">
          <div class="row">
            <div class="col-sm-6"></div>
            <div class="col-sm-6">
              <div class="text-sm-end d-sm-block">County Billing System</div>
            </div>
          </div>
        </div>
      </footer>
    </div>
  </div>
  </body>
</template>

<script>
/* eslint-disable */
import { execute, getRight, biller, liquor, authUrl, executeDownload, trade, parking, rent } from "@/api";
import NavigationBar from "@/components/Navigation.vue";
import ToolBarLiquor from "@/components/liquor/ToolBarLiquor.vue";
import ApprovedDetailsModal from "@/components/liquor/modal/ApprovedDetailsModal.vue";
import moment from "moment/moment";

export default {
  name: "CertAlcoholApproved",
  components: { ToolBarLiquor, NavigationBar, ApprovedDetailsModal },
  data() {
    return {
      download: 'Download',
      currentPage: 1,
      totalPages: 0,
      pageSize: 10,
      totalItems: 0,
      search: '',
      dateFrom: '',
      dateTo: '',
      loading: false,
      message: null,
      phoneNumber: '',
      applications: [],
      application: {},
      applicationStatuses: [],
      tradeCategories: [],
      tradeSubCategories: [],
      subCounties: [],
      wards: [],
      billDetails: {
        billNo: '',
        incomeTypeDescription: '',
        billBalance: 0,
        detailAmount: 0
      },
      billInfo: {},
      stats: {
        totalApplications: 0,
        paidCount: 0,
        pendingCount: 0,
        totalInvoiced: 0,
        totalPaid: 0,
        totalBalance: 0
      },
      // Payment states
      paymentPanel: true,
      paymentMethod: false,
      transactionSummary: false,
      transactionCompleted: false,
      paymentData: {
        bankReceiptNo: null,
        accNo: null,
        payBillNo: null,
        amount: null,
        phoneNumber: null,
        success: false,
        paymentMode: null,
        sessionNames: null,
        sessionIdNo: null,
        sessionPhoneNumber: null
      },
      receiptDetails: {
        receiptNo: null,
        billNo: '',
        receiptAmount: 0
      },
      timer: null
    }
  },
  computed: {
    visiblePages() {
      const pages = [];
      const total = this.totalPages || 1;
      const current = this.currentPage;

      if (total <= 5) {
        for (let i = 1; i <= total; i++) pages.push(i);
      } else {
        if (current <= 3) {
          pages.push(1, 2, 3, 4, '...', total);
        } else if (current >= total - 2) {
          pages.push(1, '...', total - 3, total - 2, total - 1, total);
        } else {
          pages.push(1, '...', current - 1, current, current + 1, '...', total);
        }
      }
      return pages;
    }
  },
  mounted() {
    this.dateFrom = moment().subtract(1, 'year').format('YYYY-MM-DD');
    this.dateTo = moment().format('YYYY-MM-DD');
    this.init();
  },
  watch: {
    search() {
      this.currentPage = 1;
      this.getApplications(this.search);
    },
    pageSize() {
      this.currentPage = 1;
      this.getApplications("");
    },
    dateFrom() {
      if (this.dateFrom && this.dateTo) {
        this.getApplications("");
        this.getStats();
      }
    },
    dateTo() {
      if (this.dateFrom && this.dateTo) {
        this.getApplications("");
        this.getStats();
      }
    }
  },
  methods: {
    init() {
      this.menuAccess();
      this.getTradeCategory();
      this.getSubCounties();
      this.getApplications("");
      this.getStats();
    },

    menuAccess() {
      const data = new FormData();
      data.append("function", "menuAccess");
      data.append("menu", "Cert Alcohol Approved");
      data.append("sessionNames", sessionStorage.getItem("sessionNames"));
      data.append("sessionIdNo", sessionStorage.getItem("sessionIdNo"));
      execute(data, biller);
    },

    getRight(type) {
      return getRight(type);
    },

    resetFilters() {
      this.search = '';
      this.dateFrom = moment().subtract(1, 'year').format('YYYY-MM-DD');
      this.dateTo = moment().format('YYYY-MM-DD');
      this.currentPage = 1;
      this.getApplications("");
    },

    getStats() {
      const data = new FormData();
      data.append("function", "getApplicationStats");
      data.append("statusID", "4");
      data.append("dateFrom", this.dateFrom);
      data.append("dateTo", this.dateTo);
      execute(data, liquor)
          .then((res) => {
            if (res.data.success && res.data.data.stats) {
              this.stats = res.data.data.stats;
            }
          })
          .catch(() => {});
    },

    getProgressWidth(type) {
      const total = this.stats.totalApplications || 1;
      if (type === 'paid') return ((this.stats.paidCount / total) * 100) + '%';
      if (type === 'pending') return ((this.stats.pendingCount / total) * 100) + '%';
      return '0%';
    },

    getInitials(name) {
      if (!name) return '?';
      return name.split(' ').map(n => n[0]).join('').substring(0, 2).toUpperCase();
    },

    formatDate(dateString) {
      if (!dateString || dateString === '-') return '-';
      return moment(dateString).format('DD MMM YYYY');
    },

    formatCurrency(amount) {
      if (!amount || isNaN(amount)) return 'KES 0';
      return 'KES ' + parseFloat(amount).toLocaleString('en-KE');
    },

    numberFormat(num) {
      return new Intl.NumberFormat("en-GB").format(num);
    },

    prevPage() {
      if (this.currentPage > 1) {
        this.currentPage--;
        this.getApplications("");
      }
    },

    nextPage() {
      if (this.currentPage < this.totalPages) {
        this.currentPage++;
        this.getApplications("");
      }
    },

    goToPage(page) {
      if (page >= 1 && page <= this.totalPages) {
        this.currentPage = page;
        this.getApplications("");
      }
    },

    getSubCounties() {
      const data = new FormData();
      data.append("function", "getSubCounties");
      execute(data, authUrl).then((res) => {
        if (res.data.success) this.subCounties = res.data.data.subCounties;
      });
    },

    getWards(subCountyID) {
      const data = new FormData();
      data.append("function", "getWards");
      data.append("subCountyID", subCountyID);
      execute(data, authUrl).then((res) => {
        if (res.data.success) this.wards = res.data.data.wards;
      });
    },

    getTradeCategory() {
      const data = new FormData();
      data.append("function", "getIncomeTypes");
      data.append("incomeTypePrefix", "SBP");
      execute(data, biller).then((res) => {
        if (res.data.success) this.tradeCategories = res.data.data.incomeTypes;
      });
    },

    getTradeSubCategory(event) {
      this.getApplications(event.target.value);
      const data = new FormData();
      data.append("function", "getFeesAndCharges");
      data.append("incomeTypeId", event.target.value);
      execute(data, biller).then((res) => {
        if (res.data.success) this.tradeSubCategories = res.data.data.feesAndCharges;
      });
    },

    selectedTradeSubCategory(event) {
      if (!event.target.value) return;
      this.getApplications(JSON.parse(event.target.value).feeId);
    },

    selectedSubCounty(event) {
      if (!event.target.value) return;
      const data = JSON.parse(event.target.value);
      this.getWards(data.subCountyID);
      this.getApplications(data.subCountyName);
    },

    selectedWard(event) {
      if (!event.target.value) return;
      this.getApplications(JSON.parse(event.target.value).wardName);
    },

    getApplications(search) {
      this.loading = true;
      this.applications = [];
      const data = new FormData();
      data.append("function", "getApplications");
      data.append("statusID", "4");
      data.append("search", search);
      data.append("printable", "false");
      data.append("invoiceApproved", "true");
      data.append("dateFrom", this.dateFrom);
      data.append("dateTo", this.dateTo);
      data.append("page", this.currentPage);
      data.append("rows_per_page", this.pageSize);
      execute(data, liquor).then((res) => {
        this.loading = false;
        if (res.data.success) {
          this.applications = res.data.data.applications || [];
          this.totalItems = res.data.data.totalItems?.count || this.applications.length;
          this.totalPages = Math.ceil(this.totalItems / this.pageSize) || 1;
          this.calculateLocalStats();
        }
      }).catch(() => { this.loading = false; });
    },

    calculateLocalStats() {
      let totalInvoiced = 0;
      let totalPaid = 0;
      let paidCount = 0;

      this.applications.forEach(app => {
        totalInvoiced += parseFloat(app.licenceDetailAmount) || 0;
        totalPaid += parseFloat(app.licenceReceiptAmount) || 0;
        if (parseFloat(app.licenceBillBalance) === 0) paidCount++;
      });

      this.stats.totalApplications = this.totalItems;
      this.stats.paidCount = paidCount;
      this.stats.pendingCount = this.applications.length - paidCount;
      this.stats.totalInvoiced = totalInvoiced;
      this.stats.totalPaid = totalPaid;
      this.stats.totalBalance = totalInvoiced - totalPaid;
    },

    getApplicationStatus() {
      const data = new FormData();
      data.append("function", "getApplicationStatus");
      data.append("billNo", this.application.billNo);
      execute(data, liquor).then((res) => {
        if (res.data.success) {
          const statuses = res.data.data.applicationStatuses;
          const invoicingStatus = statuses.find(s => s.status === "Invoicing");
          const otherStatuses = statuses.filter(s => s.status !== "Invoicing");
          this.applicationStatuses = invoicingStatus ? [invoicingStatus, ...otherStatuses] : statuses;
        }
      });
    },

    downloadApplications() {
      this.download = "Wait...";
      const data = new FormData();
      data.append("function", "downloadApplications");
      data.append("statusID", "4");
      data.append("dateFrom", this.dateFrom);
      data.append("dateTo", this.dateTo);
      executeDownload(data, liquor).then(response => {
        this.download = "Download";
        const link = document.createElement('a');
        link.href = URL.createObjectURL(response.data);
        link.download = `approved_applications_${this.dateFrom}_to_${this.dateTo}.csv`;
        document.body.appendChild(link);
        link.click();
        document.body.removeChild(link);
      });
    },

    applicationDetails(item) {
      this.application = { ...item };
      this.getBill(item.licenceBillNo);
      this.getApplicationStatus();
    },

    printViewBill(item) {
      this.billDetails.billNo = item.licenceBillNo;
      this.printBill();
    },

    handlePrintBill(billNo) {
      this.billDetails.billNo = billNo;
      this.printBill();
    },

    printBill() {
      localStorage['params'] = JSON.stringify({ billNo: this.billDetails.billNo });
      window.open(this.$router.resolve({ name: 'bill' }).href, '_blank');
    },

    printReceipt() {
      if (!this.receiptDetails.receiptNo) {
        alert("Receipt not available");
        return;
      }
      localStorage['params'] = JSON.stringify({ receiptNo: this.receiptDetails.receiptNo });
      window.open(this.$router.resolve({ name: 'receipt' }).href, '_blank');
    },

    // Payment Methods - Redirect to BulkReceipts
    openPaymentModal(billNo) {
      this.$router.push({
        name: 'bulk-receipts',
        query: { billNo: billNo }
      });
    },

    resetPaymentState() {
      this.paymentPanel = true;
      this.paymentMethod = false;
      this.transactionSummary = false;
      this.transactionCompleted = false;
      this.phoneNumber = '';
      this.paymentData.bankReceiptNo = null;
      this.message = null;
    },

    getBill(billNo) {
      const data = new FormData();
      data.append("function", "getBill");
      data.append("billNo", billNo);
      execute(data, biller).then((res) => {
        if (res.data.success) {
          this.billDetails = res.data.data.billDetails;
          this.billInfo = res.data.data.billInfo;
          this.paymentData.amount = res.data.data.billDetails.billBalance;
          this.paymentData.accNo = res.data.data.billDetails.billNo;
          this.paymentData.sessionNames = sessionStorage.getItem("sessionNames");
          this.paymentData.sessionIdNo = sessionStorage.getItem("sessionIdNo");
          this.paymentData.sessionPhoneNumber = sessionStorage.getItem("sessionPhoneNumber");
        }
      });
    },

    showPaymentMethod() {
      this.paymentPanel = false;
      this.paymentMethod = true;
      this.transactionSummary = false;
      this.transactionCompleted = false;
    },

    showTransactionSummary(paymentMode) {
      this.paymentData.paymentMode = paymentMode;

      if (paymentMode === "MPESA" && !this.phoneNumber) {
        alert("Enter phone number");
        return;
      }

      if (paymentMode === "BANK" && !this.paymentData.bankReceiptNo) {
        alert("Enter Bank Receipt No");
        return;
      }

      this.paymentMethod = false;
      this.paymentPanel = false;
      this.transactionSummary = true;
      this.transactionCompleted = false;
    },

    makePayment() {
      if (this.paymentData.paymentMode === "MPESA" && !this.phoneNumber) {
        alert("Enter phone number");
        return;
      }

      if (this.paymentData.paymentMode === "BANK" && !this.paymentData.bankReceiptNo) {
        alert("Enter Bank Receipt No");
        return;
      }

      this.message = "Sending payment request...";
      this.paymentData.phoneNumber = this.phoneNumber;

      const data = new FormData();
      data.append("function", "makePayment");
      data.append("paymentData", JSON.stringify(this.paymentData));

      let stream = biller;
      if (this.paymentData.accNo.startsWith("SBP")) stream = trade;
      if (this.paymentData.accNo.startsWith("PKN")) stream = parking;
      if (this.paymentData.accNo.startsWith("RNT")) stream = rent;

      execute(data, stream).then((res) => {
        if (res.data.success) {
          this.message = "Waiting for payment...";
          this.timer = setInterval(() => this.checkPayment(), 3000);
        } else {
          alert(res.data.message);
        }
      }).catch((e) => alert(e.message));
    },

    checkPayment() {
      const dots = ['.', '..', '...'];
      this.message = "Waiting for payment" + dots[Math.floor(Math.random() * 3)];

      const data = new FormData();
      data.append("function", "checkPayment");
      data.append("accountRef", this.paymentData.accNo);
      execute(data, biller).then((res) => {
        if (res.data.success) {
          clearInterval(this.timer);
          this.receiptDetails = res.data.data.receipt.receiptDetails;
          this.transactionSummary = false;
          this.transactionCompleted = true;
          this.getApplications("");
        }
      });
    }
  }
}
</script>

<style scoped>
/* Page Header */
.page-header-box {
  background: #f8f9fa;
  padding: 20px 24px;
  border-radius: 0;
  border-bottom: 3px solid #1a2b4a;
}

.page-header-title {
  font-size: 16px;
  font-weight: 700;
  color: #1a2b4a;
  margin-bottom: 4px;
  letter-spacing: 0.5px;
}

.page-header-description {
  font-size: 13px;
  color: #6c757d;
  margin-bottom: 0;
}

/* Gradient Background */
.bg-gradient-approved {
  background: linear-gradient(135deg, #11998e 0%, #38ef7d 100%) !important;
}

/* Stat Cards */
.stat-card {
  border-radius: 12px;
  transition: transform 0.2s ease, box-shadow 0.2s ease;
}

.stat-card:hover {
  transform: translateY(-3px);
  box-shadow: 0 10px 30px rgba(0,0,0,0.12) !important;
}

.stat-icon-wrapper {
  width: 48px;
  height: 48px;
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 1.5rem;
}

.bg-primary-subtle { background-color: rgba(102, 126, 234, 0.15); }
.bg-warning-subtle { background-color: rgba(255, 193, 7, 0.15); }
.bg-success-subtle { background-color: rgba(25, 135, 84, 0.15); }

/* Header Icon */
.header-icon {
  width: 45px;
  height: 45px;
  background: linear-gradient(135deg, #11998e 0%, #38ef7d 100%);
  border-radius: 10px;
  display: flex;
  align-items: center;
  justify-content: center;
  color: white;
  font-size: 1.25rem;
}

/* Search Box */
.search-box {
  position: relative;
  width: 240px;
}

.search-box .search-icon {
  position: absolute;
  left: 12px;
  top: 50%;
  transform: translateY(-50%);
  color: #adb5bd;
}

.search-box .form-control {
  padding-left: 38px;
  border-radius: 8px;
  border: 1px solid #e9ecef;
  font-size: 0.875rem;
  height: 38px;
}

.search-box .form-control:focus {
  border-color: #38ef7d;
  box-shadow: 0 0 0 3px rgba(56, 239, 125, 0.15);
}

/* Date Input */
.date-input {
  width: 130px;
  border-radius: 6px;
  font-size: 0.8125rem;
}

/* Avatar */
.avatar-sm {
  width: 36px;
  height: 36px;
}

.avatar-title {
  width: 100%;
  height: 100%;
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 0.8rem;
}

/* Buttons */
.btn-soft-primary {
  background-color: rgba(102, 126, 234, 0.1);
  color: #667eea;
  border: none;
}

.btn-soft-primary:hover {
  background-color: rgba(102, 126, 234, 0.2);
}

.btn-soft-success {
  background-color: rgba(25, 135, 84, 0.1);
  color: #198754;
  border: none;
}

.btn-soft-success:hover {
  background-color: rgba(25, 135, 84, 0.2);
}

.btn-soft-warning {
  background-color: rgba(255, 193, 7, 0.15);
  color: #997404;
  border: none;
}

.btn-soft-warning:hover {
  background-color: rgba(255, 193, 7, 0.25);
}

.btn-soft-secondary {
  background-color: #f1f3f5;
  color: #495057;
  border: none;
}

.btn-soft-secondary:hover {
  background-color: #e9ecef;
}

.rounded-circle.btn {
  width: 32px;
  height: 32px;
  padding: 0;
  display: inline-flex;
  align-items: center;
  justify-content: center;
}

/* Empty State */
.empty-icon {
  width: 80px;
  height: 80px;
  background: #f8f9fa;
  border-radius: 50%;
  display: flex;
  align-items: center;
  justify-content: center;
  margin: 0 auto;
  font-size: 2.5rem;
  color: #adb5bd;
}

/* Pagination */
.pagination .page-link {
  border: none;
  padding: 0.4rem 0.75rem;
  color: #6c757d;
  border-radius: 6px;
  margin: 0 2px;
}

.pagination .page-item.active .page-link {
  background: linear-gradient(135deg, #11998e 0%, #38ef7d 100%);
  color: white;
}

/* Table */
table tbody tr {
  transition: background-color 0.15s ease;
}

table tbody tr:hover {
  background-color: #f0fff4;
}

/* Payment Modal */
.payment-modal-icon {
  width: 40px;
  height: 40px;
  background: linear-gradient(135deg, #11998e 0%, #38ef7d 100%);
  border-radius: 10px;
  display: flex;
  align-items: center;
  justify-content: center;
  color: white;
  font-size: 1.25rem;
}

.amount-display {
  padding: 1rem;
  background: #f8f9fa;
  border-radius: 10px;
}

.success-icon {
  font-size: 5rem;
}

/* Responsive */
@media (max-width: 992px) {
  .search-box { width: 100%; }
  .date-input { width: 120px; }
}
</style>